import { useState, useRef, useCallback, useLayoutEffect, useEffect } from 'react';
import { computeMood, valueToLookX } from './mascotMood';

// Maskotun aktif alanın üst-sağ köşesinde "tepeden bakar" gibi durması için,
// input'un üstünden bu kadar px yukarıda konumlanır (göz düğmesini örtmemesi için).
// Görsel ince ayar: bu değeri ve MascotLayer'daki `right`'ı QA'da gerekiyorsa değiştir.
const VERTICAL_NUDGE = 46;

export default function useLoginMascot() {
  const containerRef = useRef(null);
  const [activeField, setActiveField] = useState('email'); // email autoFocus → açılışta email
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('idle');
  const [lookX, setLookX] = useState(0);
  const [translateY, setTranslateY] = useState(0);
  const errorTimer = useRef(null);

  const measure = useCallback(() => {
    const card = containerRef.current;
    if (!card || !activeField) return;
    const input = card.querySelector(`[name="${activeField}"]`);
    if (!input) return;
    const cardRect = card.getBoundingClientRect();
    const inputRect = input.getBoundingClientRect();
    setTranslateY(inputRect.top - cardRect.top - VERTICAL_NUDGE);
  }, [activeField]);

  useLayoutEffect(() => { measure(); }, [measure]);

  useEffect(() => {
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [measure]);

  useEffect(() => () => clearTimeout(errorTimer.current), []);

  const onFocus = useCallback((e) => {
    const name = e.target?.name;
    if (name === 'email' || name === 'password') {
      setActiveField(name);
      setLookX(0);
    } else {
      setActiveField(null);
    }
  }, []);

  const onBlur = useCallback((e) => {
    const nextName = e.relatedTarget?.name;
    if (nextName !== 'email' && nextName !== 'password') {
      setActiveField(null);
    }
  }, []);

  const onPasswordVisibilityChange = useCallback((visible) => setPasswordVisible(visible), []);
  const onFieldType = useCallback((value) => setLookX(valueToLookX(value)), []);

  const notifySubmit = useCallback((status) => {
    setSubmitStatus(status);
    clearTimeout(errorTimer.current);
    if (status === 'error') {
      errorTimer.current = setTimeout(() => setSubmitStatus('idle'), 1300);
    }
  }, []);

  const mood = computeMood({ activeField, passwordVisible, submitStatus });

  return {
    containerRef,
    formHandlers: { onFocus, onBlur },
    onPasswordVisibilityChange,
    onFieldType,
    notifySubmit,
    mood,
    lookX,
    mascotStyle: { transform: `translateY(${translateY}px)` },
  };
}
